import { Typography, Box } from '@mui/material';

import Form from 'components/Form';
import { IFormRegister, IFormValues } from 'routes/Main/type';

import SectionTitle from './SectionTitle';

interface Props extends IFormRegister, IFormValues {
  disabled?: boolean;
}

const contents = ['根據您的情況，目前存在以下具體條件。'];

const MethodandProcess = (props: Props) => {
  const { disabled, register, getValues, setValue } = props;

  return (
    <>
      <SectionTitle title="3. 特別注意事項" />
      <Box sx={{ width: '98%', margin: '48px auto 24px auto' }}>
        {contents.map((v, i) => (
          <Typography
            sx={{
              fontWeight: '400',
              fontSize: '14px',
              lineHeight: '24px',
              whiteSpace: 'pre-wrap',
            }}
          >
            {v}
          </Typography>
        ))}
        <Form.MuiTextField
          placeholder="输入"
          multiline
          required={false}
          minRows={3}
          disabled={disabled}
          {...register('no4')}
        />
        <Typography
          sx={{ margin: '30px 0 20px 0', fontSize: '14px', fontWeight: 500 }}
        >
          我了解氣管插管手術的必要性、手術方法以及手術可能導致的後遺症和併發症。因此，我特此請求進行此項手術。此外，我承諾將認真遵守與手術相關的所有指示，並完全配合主治醫生和手術醫生的指令和判斷。
        </Typography>
      </Box>
    </>
  );
};

export default MethodandProcess;
